(function() {
  function isVariantAvailable(variant) {
    return variant && variant.available === true;
  }

  function findFirstAvailableVariant(variants) {
    if (!Array.isArray(variants) || !variants.length) return null;
    return variants.find(function(v) { return isVariantAvailable(v); }) || null;
  }

  // Title overflow check
  function checkTitleOverflow() {
    document.querySelectorAll('.product-card__title-wrapper').forEach(function(wrapper) {
      var textEl = wrapper.querySelector('.product-card__title-text');
      if (textEl && wrapper.offsetWidth < textEl.offsetWidth) {
        wrapper.classList.add('is-overflowing');
      } else {
        wrapper.classList.remove('is-overflowing');
      }
    });
  }
  
  // Price overflow check - marquee when prices don't fit
  function checkPriceOverflow() {
    document.querySelectorAll('.product-card__price-wrapper').forEach(function(wrapper) {
      var card = wrapper.closest('.product-card');
      if (card && !card.classList.contains('product-card--price-marquee-enabled')) {
        wrapper.classList.remove('is-overflowing');
        return;
      }
      var priceRow = wrapper.querySelector('.product-card__price-row:not(.product-card__price-row--duplicate)');
      if (priceRow && wrapper.offsetWidth < priceRow.scrollWidth) {
        wrapper.classList.add('is-overflowing');
      } else {
        wrapper.classList.remove('is-overflowing');
      }
    });
  }
  
  // Media carousel functionality (images + videos)
  var cardData = new Map();
  var IMAGE_DURATION = 3000; // 3 seconds per image

  function isVideoMedia(media) {
    return media && media.tagName && media.tagName.toLowerCase() === 'video';
  }

  function hydrateVideoSources(video) {
    if (!video || video.dataset.sourcesHydrated === 'true') return;

    var deferredSources = video.querySelectorAll('source[data-src]');
    if (!deferredSources.length) {
      video.dataset.sourcesHydrated = 'true';
      return;
    }

    deferredSources.forEach(function(source) {
      var src = source.getAttribute('data-src');
      if (src) {
        source.src = src;
        source.removeAttribute('data-src');
      }
    });

    video.dataset.sourcesHydrated = 'true';
    video.load();
  }

  function startCarousel(container) {
    var currentIndex = 0;
var timeoutId = null;
var videoEndedHandler = null;
var isPaused = false;

function restartTimer() {
  if (timeoutId) {
    clearTimeout(timeoutId);
    timeoutId = null;
  }

  if (!isPaused) {
    scheduleNextSlide();
  }
}

// // Click image/video to go next
// container.addEventListener('click', function(e) {
//   if (e.target.closest('.product-card__progress-pill')) return;

//   nextSlide();
// });
// Pause on hover
container.addEventListener('mouseenter', function() {
  isPaused = true;

  if (timeoutId) {
    clearTimeout(timeoutId);
    timeoutId = null;
  }

  var media = mediaItems[currentIndex];
  if (isVideoMedia(media)) {
    media.pause();
  }
});

// Resume on leave
container.addEventListener('mouseleave', function() {
  isPaused = false;
});

    var mediaItems = container.querySelectorAll('.product-card__media');
    var progressContainer = container.querySelector('.product-card__image-progress');
    var pill = progressContainer ? progressContainer.querySelector('.product-card__progress-pill') : null;
    var mediaCount = parseInt(container.getAttribute('data-media-count'), 10);
    
    if (mediaCount <= 1) return;
    if (cardData.has(container)) return; // Already running
    
    var currentIndex = 0;
    var timeoutId = null;
    var videoEndedHandler = null;
    
    function setPillDuration(durationMs) {
      if (pill) {
        pill.style.setProperty('--pill-duration', (durationMs / 1000) + 's');
      }
    }
    
    function restartPillAnimation() {
      if (pill) {
        pill.classList.remove('is-filling');
        void pill.offsetWidth; // Force reflow
        pill.classList.add('is-filling');
      }
    }
    
    function nextSlide() {
      var nextIndex = (currentIndex + 1) % mediaCount;
      showSlide(nextIndex);
    }
    // Click left/right arrows or image to change slide
var nextArrow = container.querySelector('.product-card__arrow--next');
var prevArrow = container.querySelector('.product-card__arrow--prev');

if (nextArrow) {
  nextArrow.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    nextSlide();
  });
}

if (prevArrow) {
  prevArrow.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    var prevIndex = (currentIndex - 1 + mediaCount) % mediaCount;
    showSlide(prevIndex);
  });
}
    
    function scheduleNextSlide() {
        // if (isPaused) return;
        return; // Disable auto slide
      var currentMedia = mediaItems[currentIndex];
      var isVideo = isVideoMedia(currentMedia);
      
      // Clean up previous handler
      if (videoEndedHandler) {
        mediaItems.forEach(function(m) {
          if (isVideoMedia(m)) {
            m.removeEventListener('ended', videoEndedHandler);
          }
        });
      }
      
      if (isVideo) {
        hydrateVideoSources(currentMedia);

        // Create new handler for this video
        videoEndedHandler = function() {
          nextSlide();
        };
        currentMedia.addEventListener('ended', videoEndedHandler, { once: true });
        
        // Set pill duration to video duration
        if (currentMedia.duration && !isNaN(currentMedia.duration)) {
          setPillDuration(currentMedia.duration * 1000);
          restartPillAnimation();
        } else {
          // Wait for metadata
          currentMedia.addEventListener('loadedmetadata', function() {
            if (currentMedia.duration && !isNaN(currentMedia.duration)) {
              setPillDuration(currentMedia.duration * 1000);
              restartPillAnimation();
            }
          }, { once: true });
          // Start with default for now
          setPillDuration(IMAGE_DURATION);
          restartPillAnimation();
        }
      } else {
        // For images, use fixed duration
        setPillDuration(IMAGE_DURATION);
        restartPillAnimation();
        timeoutId = setTimeout(nextSlide, IMAGE_DURATION);
      }
    }
    
    function showSlide(newIndex) {
      var prevIndex = currentIndex;
      currentIndex = newIndex;
      
      // Clear any pending timeout
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      
      // Smooth crossfade between media
      mediaItems.forEach(function(media, i) {
        var isVideo = isVideoMedia(media);
        
        if (i === prevIndex && i !== newIndex) {
          media.classList.add('is-leaving');
          media.classList.remove('is-active');
          if (isVideo) {
            media.pause();
            media.currentTime = 0;
          }
        } else if (i === newIndex) {
          media.classList.remove('is-leaving');
          media.classList.add('is-active');
          if (isVideo) {
            hydrateVideoSources(media);
            media.currentTime = 0;
            media.play().catch(function() {});
          }
        } else {
          media.classList.remove('is-active', 'is-leaving');
          if (isVideo) {
            media.pause();
            media.currentTime = 0;
          }
        }
      });
      
      // Remove leaving class after transition
      setTimeout(function() {
        mediaItems.forEach(function(media) {
          media.classList.remove('is-leaving');
        });
      }, 600);
      
      // // Schedule next slide
      // scheduleNextSlide();
    }
    
    // Initial setup - show first slide
    var firstMedia = mediaItems[0];
    var isFirstVideo = isVideoMedia(firstMedia);
    
    // Make sure first is active
    firstMedia.classList.add('is-active');
    
    // Start first video if needed
    if (isFirstVideo) {
      hydrateVideoSources(firstMedia);
      firstMedia.currentTime = 0;
      firstMedia.play().catch(function() {});
    }
    
    // Schedule next slide (this also starts the pill animation)
    scheduleNextSlide();
    
    cardData.set(container, {
      currentIndex: currentIndex,
      cleanup: function() {
        if (timeoutId) clearTimeout(timeoutId);
        if (videoEndedHandler) {
          mediaItems.forEach(function(media) {
            if (isVideoMedia(media)) {
              media.removeEventListener('ended', videoEndedHandler);
            }
          });
        }
      }
    });
  }
  
  function stopCarousel(container) {
    var data = cardData.get(container);
    if (data) {
      if (data.cleanup) data.cleanup();
      cardData.delete(container);
    }
    
    // Reset to first media smoothly
    var mediaItems = container.querySelectorAll('.product-card__media');
    var pill = container.querySelector('.product-card__progress-pill');
    
    mediaItems.forEach(function(media, i) {
      var isVideo = isVideoMedia(media);
      media.classList.remove('is-leaving');
      media.classList.toggle('is-active', i === 0);
      
      if (isVideo) {
        media.pause();
        media.currentTime = 0;
      }
    });
    
    if (pill) {
      pill.classList.remove('is-filling');
      pill.style.removeProperty('--pill-duration');
    }
  }
  
  function initCarousels() {
    var containers = document.querySelectorAll('.product-card__image-container[data-media-count]');
    
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          startCarousel(entry.target);
        } else {
          stopCarousel(entry.target);
        }
      });
    }, {
      threshold: 0.5
    });
    
    containers.forEach(function(container) {
      var mediaCount = parseInt(container.getAttribute('data-media-count'), 10);
      if (mediaCount > 1) {
        observer.observe(container);
      }
    });
    
    // Handle single video cards (autoplay when in view, these keep loop attribute)
    var singleVideoCards = document.querySelectorAll('.product-card__image-container:not([data-media-count]) .product-card__video');
    if (singleVideoCards.length > 0) {
      var videoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            hydrateVideoSources(video);
            video.play().catch(function() {});
          } else {
            video.pause();
          }
        });
      }, {
        threshold: 0.5
      });
      
      singleVideoCards.forEach(function(video) {
        videoObserver.observe(video);
      });
    }
  }
  
  // Badge rotation functionality
  var badgeData = new Map();
  
  function startBadgeRotation(container) {
    var badges = container.querySelectorAll('.product-card__badge');
    var rotationSpeed = parseInt(container.getAttribute('data-rotation-speed'), 10) || 3;
    var rotationMs = rotationSpeed * 1000;
    
    if (badges.length <= 1) return;
    if (badgeData.has(container)) return; // Already running
    
    var currentIndex = 0;
    var isPaused = false;



    // Set initial active state
    badges[0].classList.add('is-active');
    
    function showBadge(newIndex) {
      var prevIndex = currentIndex;
      currentIndex = newIndex;
      
      badges.forEach(function(badge, i) {
        if (i === prevIndex && i !== newIndex) {
          badge.classList.add('is-leaving');
          badge.classList.remove('is-active');
        } else if (i === newIndex) {
          badge.classList.remove('is-leaving');
          badge.classList.add('is-active');
        } else {
          badge.classList.remove('is-active', 'is-leaving');
        }
      });
      
      // Remove leaving class after transition
      setTimeout(function() {
        badges.forEach(function(badge) {
          badge.classList.remove('is-leaving');
        });
      }, 300);
    }
    
    function nextBadge() {
      var nextIndex = (currentIndex + 1) % badges.length;
      showBadge(nextIndex);
    }
    
    var intervalId = setInterval(nextBadge, rotationMs);
    badgeData.set(container, { intervalId: intervalId });
  }
  
  function stopBadgeRotation(container) {
    var data = badgeData.get(container);
    if (data) {
      clearInterval(data.intervalId);
      badgeData.delete(container);
    }
    
    // Reset to first badge
    var badges = container.querySelectorAll('.product-card__badge');
    badges.forEach(function(badge, i) {
      badge.classList.remove('is-leaving');
      badge.classList.toggle('is-active', i === 0);
    });
  }
  
  function initBadgeRotation() {
    var rotatingContainers = document.querySelectorAll('.product-card__badges--rotating');
    
    if (rotatingContainers.length === 0) return;
    
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          startBadgeRotation(entry.target);
        } else {
          stopBadgeRotation(entry.target);
        }
      });
    }, {
      threshold: 0.3
    });
    
    rotatingContainers.forEach(function(container) {
      observer.observe(container);
    });
  }
  
  function formatMoney(cents, format) {
    if (window.formatMoney) {
      return window.formatMoney(cents, format);
    }
    if (window.formatMoneyFallback) {
      return window.formatMoneyFallback(cents);
    }
    return (Number(cents || 0) / 100).toFixed(2);
  }

  function initSelectComponentsSafe() {
    if (!window.SelectComponent) return;
    document.querySelectorAll('[data-select]').forEach(function(el) {
      if (!el._selectComponent) {
        el._selectComponent = new window.SelectComponent(el);
      }
    });
  }

  function getSizedImageUrl(src, card) {
    if (!src) return src;
    if (!card) return src;
    var isCover = card.classList.contains('product-card--fit-cover');
    if (isCover) {
      return src.replace(/(\.[^.]+)$/, '_600x800_crop_center$1');
    }
    return src.replace(/(\.[^.]+)$/, '_600x$1');
  }

  function updatePriceRow(row, price, comparePrice, moneyFormat) {
    var priceEl = row.querySelector('.product-card__price');
    if (priceEl) {
      priceEl.textContent = formatMoney(price, moneyFormat);
    }

    var compareEl = row.querySelector('.product-card__compare-price');
    if (comparePrice && comparePrice > price) {
      if (!compareEl && priceEl) {
        compareEl = priceEl.cloneNode(true);
        compareEl.classList.remove('product-card__price');
        compareEl.classList.add('product-card__compare-price');
        priceEl.insertAdjacentElement('afterend', compareEl);
      }
      if (compareEl) {
        compareEl.textContent = formatMoney(comparePrice, moneyFormat);
      }
    } else if (compareEl) {
      compareEl.remove();
    }
  }

  function updatePriceDisplay(card, price, comparePrice) {
    var priceWrapper = card.querySelector('.product-card__price-wrapper');
    if (!priceWrapper) return;

    var moneyFormat = card.getAttribute('data-money-format') || window.themeMoneyFormat;
    var rows = priceWrapper.querySelectorAll('.product-card__price-row');
    rows.forEach(function(row) {
      updatePriceRow(row, price, comparePrice, moneyFormat);
    });

      checkPriceOverflow();
  }

  function updateProductImage(card, variant, fallbackImageSrc) {
    var imageEl = card.querySelector('.product-card__image.is-active') || card.querySelector('.product-card__image');
    if (!imageEl) return;

    if (variant && variant.featured_image && variant.featured_image.src) {
      imageEl.src = getSizedImageUrl(variant.featured_image.src, card);
      return;
    }

    if (fallbackImageSrc) {
      imageEl.src = fallbackImageSrc;
    }
  }

  function updateProductLinks(card, variantId) {
    var productLink = card.querySelector('.product-card__image-container');
    if (productLink && productLink.getAttribute('href')) {
      var baseLink = productLink.getAttribute('href').split('?')[0];
      productLink.setAttribute('href', baseLink + '?variant=' + variantId);
    }

    var addBtn = card.querySelector('.product-card__add-btn');
    if (addBtn && addBtn.tagName.toLowerCase() === 'a' && addBtn.getAttribute('href')) {
      var baseBtnLink = addBtn.getAttribute('href').split('?')[0];
      addBtn.setAttribute('href', baseBtnLink + '?variant=' + variantId);
    }
  }

  function normalizeToken(value) {
    if (value === null || value === undefined) return '';
    return String(value).toLowerCase().trim();
  }

  function escapeHtml(value) {
    return String(value === null || value === undefined ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function variantOptionValue(variant, optionIndex) {
    if (!variant) return '';
    if (optionIndex === 0) return variant.option1 || '';
    if (optionIndex === 1) return variant.option2 || '';
    if (optionIndex === 2) return variant.option3 || '';
    return '';
  }

  function findColorOptionIndex(optionNames) {
    if (!Array.isArray(optionNames)) return -1;
    for (var i = 0; i < optionNames.length; i += 1) {
      var optionName = normalizeToken(optionNames[i]);
      if (optionName === 'color' || optionName === 'colour') {
        return i;
      }
    }
    return -1;
  }

  var COLOR_HEX_MAP = {
    'black':'#000000','white':'#ffffff','red':'#dc2626','blue':'#2563eb','green':'#16a34a',
    'yellow':'#eab308','orange':'#ea580c','pink':'#ec4899','purple':'#9333ea','brown':'#78350f',
    'gray':'#6b7280','grey':'#6b7280','navy':'#1e3a5f','beige':'#d4b896','cream':'#fffdd0',
    'ivory':'#fffff0','tan':'#d2b48c','khaki':'#c3b091','olive':'#556b2f','teal':'#0d9488',
    'coral':'#ff6f61','salmon':'#fa8072','burgundy':'#800020','maroon':'#800000','mauve':'#b784a7',
    'lavender':'#e6e6fa','lilac':'#c8a2c8','mint':'#98fb98','sage':'#9caf88','forest':'#228b22',
    'emerald':'#50c878','jade':'#00a36c','charcoal':'#36454f','slate':'#708090','silver':'#c0c0c0',
    'ash':'#b2beb5','rust':'#b7410e','copper':'#b87333','bronze':'#cd7f32','gold':'#ffd700',
    'champagne':'#f7e7ce','camel':'#c19a6b','sand':'#c2b280','taupe':'#483c32','chocolate':'#7b3f00',
    'espresso':'#3c1414','mocha':'#967969','coffee':'#6f4e37','caramel':'#ffd59a','peach':'#ffcba4',
    'apricot':'#fbceb1','rose':'#ff007f','blush':'#de5d83','fuchsia':'#ff00ff','magenta':'#ff00ff',
    'berry':'#8e4585','plum':'#8e4585','wine':'#722f37','cherry':'#de3163','ruby':'#e0115f',
    'crimson':'#dc143c','scarlet':'#ff2400','tomato':'#ff6347','brick':'#cb4154','clay':'#b66a50',
    'terracotta':'#e2725b','cinnamon':'#d2691e','amber':'#ffbf00','mustard':'#ffdb58','lemon':'#fff44f',
    'lime':'#32cd32','chartreuse':'#7fff00','pine':'#01796f','hunter':'#355e3b','moss':'#8a9a5b',
    'seafoam':'#93e9be','aqua':'#00ffff','cyan':'#00ffff','turquoise':'#40e0d0','sky':'#87ceeb',
    'cobalt':'#0047ab','royal':'#4169e1','indigo':'#4b0082','midnight':'#191970','denim':'#1560bd',
    'periwinkle':'#ccccff','violet':'#7f00ff','orchid':'#da70d6','dusty rose':'#dcae96',
    'baby blue':'#89cff0','powder blue':'#b0e0e6','light blue':'#add8e6','dark blue':'#00008b',
    'light green':'#90ee90','dark green':'#006400','light gray':'#d3d3d3','light grey':'#d3d3d3',
    'dark gray':'#404040','dark grey':'#404040','off white':'#faf9f6','off-white':'#faf9f6',
    'natural':'#efe4d2','oatmeal':'#d8c8a8','stone':'#928e85','pewter':'#8e9091','graphite':'#383838',
    'onyx':'#353839','jet':'#343434','snow':'#fffafa','pearl':'#eae6ca','bone':'#e3dac9',
    'wheat':'#f5deb3','ecru':'#c2b280'
  };

  function colorDotStyle(value) {
    var candidate = String(value || '').trim();
    if (!candidate) return '';
    if (candidate.charAt(0) === '#') return candidate;
    if (/^rgb[a]?\(|^hsl[a]?\(/i.test(candidate)) return candidate;
    var mapped = COLOR_HEX_MAP[candidate.toLowerCase()];
    if (mapped) return mapped;
    if (/^[a-zA-Z\s-]+$/.test(candidate)) return candidate;
    return '';
  }

  function buildColorItemsFromVariants(variants, colorOptionIndex) {
    if (!Array.isArray(variants) || colorOptionIndex < 0) return [];

    var seen = {};
    var colorItems = [];
    variants.forEach(function(variant) {
      var token = normalizeToken(variantOptionValue(variant, colorOptionIndex));
      if (!token) return;

      if (seen[token]) {
        return;
      }

      seen[token] = true;
      colorItems.push({
        token: token,
        label: String(variantOptionValue(variant, colorOptionIndex)).trim() || token,
        dotStyle: colorDotStyle(variantOptionValue(variant, colorOptionIndex)),
        firstVariantId: String(variant.id || '').trim(),
        firstAvailableVariantId: isVariantAvailable(variant) ? String(variant.id || '').trim() : ''
      });
    });

    return colorItems;
  }

  function normalizeSelectSizeClass(selectWrapper, fallback) {
    if (!selectWrapper) return fallback || 'select--md';
    var className = selectWrapper.className || '';
    var match = className.match(/select--(mini|sm|md|lg|xl)/);
    return match ? ('select--' + match[1]) : (fallback || 'select--md');
  }

  function syncColorSelectSummary(selectWrapper) {
    if (!selectWrapper) return;
    var body = selectWrapper.querySelector('.select__body');
    var nativeSelect = selectWrapper.querySelector('.select__native');
    if (!body || !nativeSelect) return;
    var colorItems = selectWrapper._productCardColorItems || [];
    var currentToken = normalizeToken(nativeSelect.value);
    var item = null;
    var i;

    for (i = 0; i < colorItems.length; i += 1) {
      if (colorItems[i].token === currentToken) {
        item = colorItems[i];
        break;
      }
    }

    if (!item && colorItems.length) {
      item = colorItems[0];
      nativeSelect.value = item.token;
      if (selectWrapper._selectComponent && typeof selectWrapper._selectComponent.selectValue === 'function') {
        selectWrapper._selectComponent.selectValue(item.token);
      }
    }

    if (!item) {
      body.innerHTML = '<span class="product-card__color-select-selected-label">Color</span>';
      return;
    }

    var dotStyle = '';
    if (item.dotStyle) {
      dotStyle = ' style="background-color:' + escapeHtml(item.dotStyle) + ';"';
    }
    body.innerHTML =
      '<span class="product-card__color-select-selected">' +
        '<span class="product-card__color-select-dot" data-color-name="' + escapeHtml(item.token) + '"' + dotStyle + '></span>' +
        '<span class="select__value product-card__color-select-selected-label">' + escapeHtml(item.label) + '</span>' +
      '</span>';
  }

  function pickVariantMatchByColor(variants, colorOptionIndex, colorToken, contextVariant) {
    if (!Array.isArray(variants) || colorOptionIndex < 0 || !colorToken) return null;
    var normalizedColor = normalizeToken(colorToken);
    var best = null;
    var bestAvailable = null;
    var fallback = null;
    var fallbackAvailable = null;

    variants.forEach(function(variant) {
      if (normalizeToken(variantOptionValue(variant, colorOptionIndex)) !== normalizedColor) {
        return;
      }

      if (!fallback) {
        fallback = variant;
      }
      if (isVariantAvailable(variant) && !fallbackAvailable) {
        fallbackAvailable = variant;
      }

      if (!contextVariant) return;

      var isMatch = true;
      for (var i = 0; i < 3; i += 1) {
        if (i === colorOptionIndex) continue;
        var contextValue = normalizeToken(variantOptionValue(contextVariant, i));
        if (!contextValue) continue;
        if (normalizeToken(variantOptionValue(variant, i)) !== contextValue) {
          isMatch = false;
          break;
        }
      }
      if (!isMatch) return;

      if (!best) {
        best = variant;
      }
      if (isVariantAvailable(variant) && !bestAvailable) {
        bestAvailable = variant;
      }
    });

    if (bestAvailable) return bestAvailable;
    if (best) return best;
    if (fallbackAvailable) return fallbackAvailable;
    return fallback;
  }

  function renderColorSelect(container, colorItems, selectedToken, selectSizeClass, productId) {
    if (!container || !Array.isArray(colorItems) || colorItems.length <= 1) {
      if (container) {
        container.hidden = true;
        container.innerHTML = '';
      }
      return null;
    }

    var selectedTokenNormalized = normalizeToken(selectedToken);
    var selectName = 'product-card-color-' + String(productId || 'card');
    var nativeOptionsHtml = '';
    var listOptionsHtml = '';
    var i;

    for (i = 0; i < colorItems.length; i += 1) {
      var item = colorItems[i];
      if (!item || !item.token) continue;
      var isSelected = item.token === selectedTokenNormalized;
      var dotStyle = '';
      if (item.dotStyle) {
        dotStyle = ' style="background-color:' + escapeHtml(item.dotStyle) + ';"';
      }
      nativeOptionsHtml += '<option value="' + escapeHtml(item.token) + '"' + (isSelected ? ' selected' : '') + '>' + escapeHtml(item.label) + '</option>';
      listOptionsHtml +=
        '<li class="select__option' + (isSelected ? ' select__option--selected' : '') + '" role="option" aria-selected="' + (isSelected ? 'true' : 'false') + '" data-value="' + escapeHtml(item.token) + '">' +
          '<span class="product-card__color-select-dot" data-color-name="' + escapeHtml(item.token) + '"' + dotStyle + '></span>' +
          '<span class="select__option-label">' + escapeHtml(item.label) + '</span>' +
        '</li>';
    }

    container.innerHTML =
      '<div class="select ' + selectSizeClass + ' select--filled product-card__color-select-widget" data-select data-color-select data-select-name="' + escapeHtml(selectName) + '" data-select-multiple="false">' +
        '<select name="' + escapeHtml(selectName) + '" class="select__native" aria-hidden="true" tabindex="-1">' +
          nativeOptionsHtml +
        '</select>' +
        '<button type="button" class="select__trigger" aria-haspopup="listbox" aria-expanded="false">' +
          '<span class="select__body"></span>' +
          '<span class="select__arrow"><svg class="select__arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></span>' +
        '</button>' +
        '<div class="select__dropdown" role="listbox">' +
          '<ul class="select__options">' + listOptionsHtml + '</ul>' +
          '<div class="select__empty" style="display:none;"><span>No options found</span></div>' +
        '</div>' +
      '</div>';

    container.hidden = false;
    var wrapper = container.querySelector('[data-color-select]');
    wrapper._productCardColorItems = colorItems.slice();

    if (window.SelectComponent) {
      wrapper._selectComponent = new window.SelectComponent(wrapper);
    }

    syncColorSelectSummary(wrapper);
    return wrapper;
  }

  function rebuildMainSelectWithoutColor(nativeSelect, selectWrapper, variants, optionNames, colorIndex, selectedVariant) {
    var nonColorIndices = [];
    for (var i = 0; i < optionNames.length; i++) {
      if (i !== colorIndex) nonColorIndices.push(i);
    }
    if (!nonColorIndices.length) return;

    var seen = {};
    var groups = [];
    variants.forEach(function(v) {
      var key = nonColorIndices.map(function(idx) { return variantOptionValue(v, idx); }).join(' / ');
      if (!seen[key]) {
        seen[key] = true;
        groups.push({ label: key, variantId: String(v.id) });
      }
    });

    while (nativeSelect.options.length) nativeSelect.remove(0);
    groups.forEach(function(g) {
      var opt = document.createElement('option');
      opt.value = g.variantId;
      opt.textContent = g.label;
      nativeSelect.appendChild(opt);
    });

    if (selectedVariant) {
      var selKey = nonColorIndices.map(function(idx) { return variantOptionValue(selectedVariant, idx); }).join(' / ');
      var match = groups.find(function(g) { return g.label === selKey; });
      if (match) nativeSelect.value = match.variantId;
    }

    if (selectWrapper && selectWrapper._selectComponent && typeof selectWrapper._selectComponent.rebuild === 'function') {
      selectWrapper._selectComponent.rebuild();
    } else if (selectWrapper) {
      var triggerBody = selectWrapper.querySelector('.select__body');
      var optionsList = selectWrapper.querySelector('.select__options');
      if (triggerBody && optionsList) {
        optionsList.innerHTML = '';
        var selVal = nativeSelect.value;
        groups.forEach(function(g) {
          var li = document.createElement('li');
          li.className = 'select__option' + (g.variantId === selVal ? ' select__option--selected' : '');
          li.setAttribute('role', 'option');
          li.setAttribute('aria-selected', g.variantId === selVal ? 'true' : 'false');
          li.setAttribute('data-value', g.variantId);
          li.innerHTML = '<span class="select__option-label">' + escapeHtml(g.label) + '</span>';
          if (g.variantId === selVal) {
            li.innerHTML += '<i class="ph-bold ph-check select__check-icon"></i>';
          }
          optionsList.appendChild(li);
        });
        var selGroup = groups.find(function(g) { return g.variantId === selVal; });
        triggerBody.innerHTML = '<span class="select__value">' + escapeHtml(selGroup ? selGroup.label : '') + '</span>';
        if (window.UntamedIcons && typeof window.UntamedIcons.refresh === 'function') window.UntamedIcons.refresh();
      }
    }

    nativeSelect._colorAwareGroups = groups;
    nativeSelect._nonColorIndices = nonColorIndices;
  }

  function initVariantSelectors() {
    document.querySelectorAll('.product-card[data-product-card]').forEach(function(card) {
      if (card.hasAttribute('data-variant-controls-initialized')) return;
      card.setAttribute('data-variant-controls-initialized', 'true');

      var variantContainer = card.querySelector('.product-card__variants');
      var selectWrapper = variantContainer ? variantContainer.querySelector('[data-select]') : null;
      var nativeSelect = variantContainer ? variantContainer.querySelector('.select__native') : null;
      var colorMount = card.querySelector('[data-color-select-mount]');
      var variantsJson = card.querySelector('.product-card__variants-json');

      if (!variantsJson) return;
      if (!variantContainer && !colorMount) return;
      if (variantContainer && !nativeSelect) return;

      var productMetaJson = card.querySelector('.product-card__product-meta-json');
      var productMeta = {};
      var variantsState = [];
      var optionNamesState = [];
      var colorOptionIndexState = -1;
      var colorItems = [];
      var selectedVariantState = null;
      var colorSelectWrapper = null;
      var isSyncingColor = false;
      var fallbackImageSrc = '';

      if (productMetaJson) {
        try {
          productMeta = JSON.parse(productMetaJson.textContent || '{}');
        } catch (metaError) {
          productMeta = {};
        }
      }

      try {
        variantsState = JSON.parse(variantsJson.textContent || '[]');
      } catch (e) {
        variantsState = [];
      }
      if (!variantsState.length) return;

      optionNamesState = Array.isArray(productMeta.options) ? productMeta.options : [];
      colorOptionIndexState = findColorOptionIndex(optionNamesState);
      if (colorMount && colorOptionIndexState < 0) {
        var mountIndex = parseInt(colorMount.getAttribute('data-color-option-index') || '-1', 10);
        if (!isNaN(mountIndex)) {
          colorOptionIndexState = mountIndex;
        }
      }

      fallbackImageSrc = (card.querySelector('.product-card__image') || {}).src || '';

      selectedVariantState = variantsState.find(function(variant) {
        return nativeSelect ? String(variant.id) === String(nativeSelect.value) : false;
      }) || findFirstAvailableVariant(variantsState) || variantsState[0] || null;

      if (colorMount && colorOptionIndexState >= 0) {
        colorItems = buildColorItemsFromVariants(variantsState, colorOptionIndexState);
        colorSelectWrapper = renderColorSelect(
          colorMount,
          colorItems,
          selectedVariantState ? variantOptionValue(selectedVariantState, colorOptionIndexState) : '',
          normalizeSelectSizeClass(selectWrapper, 'select--md'),
          card.getAttribute('data-product-id')
        );

        if (colorMount.getAttribute('data-separate-color') === 'true') {
          if (nativeSelect && optionNamesState.length > 1) {
            rebuildMainSelectWithoutColor(nativeSelect, selectWrapper, variantsState, optionNamesState, colorOptionIndexState, selectedVariantState);
          } else if (variantContainer && optionNamesState.length <= 1) {
            variantContainer.style.display = 'none';
          }
        }
      }

      function updateAddButtonState(selectedVariant) {
        var addBtn = card.querySelector('[data-add-to-cart]');
        if (!addBtn) return;

        if (!selectedVariant || !selectedVariant.id) {
          addBtn.disabled = true;
          addBtn.classList.add('btn--disabled');
          addBtn.removeAttribute('data-variant-id');
          var missingVariantText = addBtn.querySelector('.btn__text');
          if (missingVariantText) missingVariantText.textContent = 'Sold Out';
          var missingVariantIcon = addBtn.querySelector('.btn__icon');
          if (missingVariantIcon) missingVariantIcon.style.display = 'none';
          return;
        }

        addBtn.dataset.variantId = selectedVariant.id;

        var productAvailable = card.getAttribute('data-product-available') !== 'false';
        if (productAvailable && isVariantAvailable(selectedVariant)) {
          addBtn.disabled = false;
          addBtn.classList.remove('btn--disabled');
          var addText = addBtn.querySelector('.btn__text');
          if (addText) addText.textContent = 'Add to Cart';
          var addIcon = addBtn.querySelector('.btn__icon');
          if (addIcon) addIcon.style.display = '';
        } else {
          addBtn.disabled = true;
          addBtn.classList.add('btn--disabled');
          var soldOutText = addBtn.querySelector('.btn__text');
          if (soldOutText) soldOutText.textContent = 'Sold Out';
          var soldOutIcon = addBtn.querySelector('.btn__icon');
          if (soldOutIcon) soldOutIcon.style.display = 'none';
        }
      }

      function syncColorSelect(variant) {
        if (!colorSelectWrapper || !variant || colorOptionIndexState < 0 || isSyncingColor) return;
        var colorToken = normalizeToken(variantOptionValue(variant, colorOptionIndexState));
        var nativeColorSelect = colorSelectWrapper.querySelector('.select__native');
        if (!nativeColorSelect || !colorToken) return;

        isSyncingColor = true;
        if (nativeColorSelect.value !== colorToken) {
          nativeColorSelect.value = colorToken;
          if (colorSelectWrapper._selectComponent && typeof colorSelectWrapper._selectComponent.selectValue === 'function') {
            colorSelectWrapper._selectComponent.selectValue(colorToken);
          } else {
            nativeColorSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        syncColorSelectSummary(colorSelectWrapper);
        isSyncingColor = false;
      }

      function syncMainSelectToSizeGroup(variant) {
        if (!nativeSelect || !nativeSelect._nonColorIndices || !nativeSelect._colorAwareGroups) return;
        var nonColorIndices = nativeSelect._nonColorIndices;
        var groups = nativeSelect._colorAwareGroups;
        var key = nonColorIndices.map(function(idx) { return variantOptionValue(variant, idx); }).join(' / ');
        var match = groups.find(function(g) { return g.label === key; });
        if (match && nativeSelect.value !== match.variantId) {
          nativeSelect.value = match.variantId;
          if (selectWrapper) {
            var triggerBody = selectWrapper.querySelector('.select__body');
            if (triggerBody) {
              triggerBody.innerHTML = '<span class="select__value">' + escapeHtml(match.label) + '</span>';
            }
            var allOpts = selectWrapper.querySelectorAll('.select__option');
            allOpts.forEach(function(li) {
              var isMatch = li.getAttribute('data-value') === match.variantId;
              li.classList.toggle('select__option--selected', isMatch);
              li.setAttribute('aria-selected', isMatch ? 'true' : 'false');
            });
          }
        }
      }

      function handleVariantChange(variantId) {
        if (!variantId) {
          updateAddButtonState(null);
          return;
        }

        var selectedVariant = variantsState.find(function(variant) {
          return String(variant.id) === String(variantId);
        });
        if (!selectedVariant) {
          updateAddButtonState(null);
          return;
        }

        selectedVariantState = selectedVariant;
        updatePriceDisplay(card, selectedVariant.price, selectedVariant.compare_at_price);
        updateProductImage(card, selectedVariant, fallbackImageSrc);
        updateProductLinks(card, selectedVariant.id);
        updateAddButtonState(selectedVariant);
        syncColorSelect(selectedVariant);
        syncMainSelectToSizeGroup(selectedVariant);
      }

      function resolveVariantFromSelections() {
        if (!nativeSelect || colorOptionIndexState < 0 || !nativeSelect._nonColorIndices) return null;
        var nonColorIndices = nativeSelect._nonColorIndices;
        var refVariant = variantsState.find(function(v) { return String(v.id) === String(nativeSelect.value); });
        if (!refVariant) return null;

        var colorNative = colorSelectWrapper ? colorSelectWrapper.querySelector('.select__native') : null;
        var activeColor = colorNative ? normalizeToken(colorNative.value) : '';
        if (!activeColor && selectedVariantState) {
          activeColor = normalizeToken(variantOptionValue(selectedVariantState, colorOptionIndexState));
        }

        return variantsState.find(function(v) {
          var colorMatch = normalizeToken(variantOptionValue(v, colorOptionIndexState)) === activeColor;
          var sizeMatch = nonColorIndices.every(function(idx) {
            return variantOptionValue(v, idx) === variantOptionValue(refVariant, idx);
          });
          return colorMatch && sizeMatch;
        }) || refVariant;
      }

      function applyColorValue(colorToken) {
        if (isSyncingColor) return;
        var nextVariant = pickVariantMatchByColor(variantsState, colorOptionIndexState, colorToken, selectedVariantState);
        if (!nextVariant) return;
        handleVariantChange(nextVariant.id);
      }

      if (nativeSelect) {
        var mainSelectHandler = function(variantId) {
          if (nativeSelect._nonColorIndices) {
            var resolved = resolveVariantFromSelections();
            if (resolved) {
              handleVariantChange(resolved.id);
              return;
            }
          }
          handleVariantChange(variantId);
        };
        if (selectWrapper) {
          selectWrapper.addEventListener('select:change', function(e) {
            mainSelectHandler(e.detail && e.detail.value);
          });
        }
        nativeSelect.addEventListener('change', function() {
          mainSelectHandler(nativeSelect.value);
        });
      }

      if (colorSelectWrapper) {
        var colorNativeSelect = colorSelectWrapper.querySelector('.select__native');
        colorSelectWrapper.addEventListener('select:change', function(event) {
          applyColorValue(event && event.detail ? event.detail.value : '');
        });
        if (colorNativeSelect) {
          colorNativeSelect.addEventListener('change', function() {
            applyColorValue(colorNativeSelect.value);
          });
        }
      }

      if (selectedVariantState) {
        handleVariantChange(selectedVariantState.id);
      } else {
        updateAddButtonState(null);
      }
    });
  }

  function initProductCards() {
    checkTitleOverflow();
    checkPriceOverflow();
    initCarousels();
    initBadgeRotation();
    initSelectComponentsSafe();
    initVariantSelectors();
    initAddToCartButtons();
  }
  
  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initProductCards();
    });
  } else {
    initProductCards();
  }

  document.addEventListener('product-card:updated', function() {
    initProductCards();
  });

  document.addEventListener('shopify:section:load', function() {
    initProductCards();
  });

  function initAddToCartButtons() {
    document.querySelectorAll('[data-product-card] [data-add-to-cart]').forEach(function(button) {
      if (button.hasAttribute('data-card-initialized')) return;
      button.setAttribute('data-card-initialized', 'true');

      button.addEventListener('click', handleAddToCart);
    });
  }

  async function handleAddToCart(e) {
    e.preventDefault();
    var button = e.currentTarget;
    var variantId = button.dataset.variantId;

    if (!variantId || button.classList.contains('btn--loading') || button.disabled) return;

    button.classList.add('btn--loading');
    button.disabled = true;

    try {
      if (window.CartAPI && window.CartAPI.addItem) {
        await window.CartAPI.addItem(parseInt(variantId, 10), 1);
      } else {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: 1
          })
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        var addedItem = await response.json();
        window.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: {
            item: addedItem
          }
        }));
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      button.classList.remove('btn--loading');
      button.disabled = false;
    }
  }
  
  function applySwatchColor(el, hex) {
    el.style.backgroundColor = hex;
  }

  // Color-swatch hydration (data-color-name → background) is handled globally
  // by assets/color-swatches.js, which loads on every page and uses the brand
  // color map shared with the product page. We intentionally do not duplicate
  // that logic here.

  // Run on resize
  window.addEventListener('resize', function() {
    checkTitleOverflow();
    checkPriceOverflow();
  });
})();
